import React from "react";
import { Button } from "nq-component";
import CardView from "../../../../components/common/CardView";
import BasePage from "../../../../base/BasePage";
import { FloatingForm } from "../../../../components/common/Converter";
export default class LibraryFormView extends BasePage {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // componentDidMount(){
  //   const { object } = this.props;
  //   console.warn("OBJECT: ", this.state.object);
  // }

  render() {
    const { object } = this.props;
    console.log("OBJECT: ", object);
    const date = new Date(object.createdAt);
    const update = new Date(object.updatedAt);
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = months[date.getUTCMonth()];
    const day = date.getUTCDate();
    const year = date.getUTCFullYear();

    const monthUpdate = months[update.getUTCMonth()];
    const dayUpdate = update.getUTCDate();
    const yearUpdate = update.getUTCFullYear();

    // Format the date string
    const formattedDate = `${month} ${day}, ${year}`;
    const formattedDateUpdate = `${monthUpdate} ${dayUpdate}, ${yearUpdate}`;
    return (
      <>
        <FloatingForm width="45rem">
          <CardView style={{ padding: 0 }}>
            <h4 className="fs-6 fw-bold pt-3 ps-3">Upload Details</h4>
            <hr />
            <div className="w-100 pt-3" style={{ padding: "0 1.5rem" }}>
              <p>
                <span style={{ color: "#888888" }}>Name:</span>{" "}
                <strong>{object.name}</strong>
              </p>
              <p>
                <span style={{ color: "#888888" }}>Date Created:</span>{" "}
                <strong>{formattedDate}</strong>
              </p>
              <p>
                <span style={{ color: "#888888" }}>Created By:</span>{" "}
                <strong>{object.user || "-"}</strong>
              </p>
              <p>
                <span style={{ color: "#888888" }}>Last Modified:</span>{" "}
                <strong>{formattedDateUpdate}</strong>
              </p>

              <p>
                <strong>Files:</strong>
              </p>
              {object.attachment?.map((file, index) => {
                const fileName = file.split("_");
                return (
                  <div key={index} className="d-flex align-items-center mb-2">
                    {typeof file === "string" && (
                      <div className="overflow-auto" style={{ width: "90%" }}>
                        <a href={file} target="_blank" rel="noreferrer">
                          {fileName[1] || file}
                        </a>
                        <hr></hr>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            <hr />
            <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
              <Button
                className="btn btn-primary fs-sm"
                onClick={() => this.props.closeCollection()}
              >
                Close
              </Button>
            </div>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}
